import {makeAutoObservable} from 'mobx';

class ControlStore {
    typesVehiclesFinished = false
    routesSchedulesControl = false
    driverFinished = false

    constructor() {
        makeAutoObservable(this);
    }

    getTypesVehiclesStatus = (status) => {
        this.typesVehiclesFinished = status
    }

    getRoutesSchedulesControl = (status) => {
        this.routesSchedulesControl = status
    }

    getDriversFinished = (status) => {
        this.driverFinished = status
    }

}

const controlStore = new ControlStore();

export default controlStore